import React from "react";

/**
 * Maps a status string to a consistent colored pill with a dot.
 * Covers attendance / leave / wfh / audit statuses used across the app.
 */
const STATUS_MAP = {
  present: { color: "#14B8A6", label: "Present" },
  late: { color: "#F59E0B", label: "Late" },
  half_day: { color: "#F59E0B", label: "Half Day" },
  on_leave: { color: "#8B5CF6", label: "On Leave" },
  wfh: { color: "#3B82F6", label: "WFH" },
  outside_geofence: { color: "#EF4444", label: "Outside Geofence" },
  auto_logged_out: { color: "#EF4444", label: "Auto Logged Out" },
  holiday: { color: "#6366F1", label: "Holiday" },
  absent: { color: "#9CA3AF", label: "Absent" },
  pending: { color: "#F59E0B", label: "Pending" },
  approved: { color: "#14B8A6", label: "Approved" },
  rejected: { color: "#EF4444", label: "Rejected" },
  active: { color: "#14B8A6", label: "Active" },
  inactive: { color: "#9CA3AF", label: "Inactive" },
  inside: { color: "#14B8A6", label: "Inside" },
  outside: { color: "#EF4444", label: "Outside" },
  bill_submitted: { color: "#3B82F6", label: "Bill Submitted" },
  reimbursed: { color: "#14B8A6", label: "Reimbursed" },
};

const humanize = (s) =>
  String(s || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

const StatusTag = ({ status }) => {
  const meta = STATUS_MAP[status] || { color: "#9CA3AF", label: humanize(status) || "Unknown" };
  return (
    <span
      className="i-ems-status-tag"
      style={{ background: `${meta.color}1A`, color: meta.color, borderColor: `${meta.color}33` }}
    >
      <span className="i-ems-status-dot" style={{ background: meta.color }} />
      {meta.label}
    </span>
  );
};

export default StatusTag;
